import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from 'pages/professional/page-header/page-header.component';
import { DropdownModule } from 'components/dropdown/dropdown.module';
import { SearchInputModule } from '@certemy/ui-components';

@NgModule({
  imports: [CommonModule, SearchInputModule, DropdownModule],
  exports: [PageHeaderComponent],
  declarations: [PageHeaderComponent],
})
export class PageHeaderModule {}
